<template>
  <div id="product_confirm">
    <div class="segment">商品情報のご入力</div>
    <div class="table_block">
      <table style="margin-top: 10px">
        <tbody>
          <tr v-if="getHasRegistration === 'change'">
            <th>申込日</th>
            <td>
              {{
                `${getUserInputForm.application_date_year}年${getUserInputForm.application_date_month}月${getUserInputForm.application_date_day}日`
              }}
            </td>
          </tr>
          <tr v-if="getHasPayment === 'installment'">
            <th>{{ ProductInputText.product }}</th>
            <td>
              <template v-for="(product, index) in getList">
                <span :key="index" v-if="product.id === getForm.product">
                  {{ product.name }}
                </span>
              </template>
              <template v-if="getForm.product_other_name"> <br />{{ getForm.product_other_name }} </template>
            </td>
          </tr>
          <tr>
            <th>{{ ProductInputText.cash_total }}</th>
            <td>{{ getForm.cash_total | isComma }}円</td>
          </tr>
          <tr>
            <th>{{ ProductInputText.down_payment }}</th>
            <td>{{ getForm.down_payment | isComma }}円</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="segment">お支払い方法のご入力</div>
    <div class="table_block">
      <table>
        <tbody>
          <tr>
            <th>{{ ProductInputText.remaining_money }}</th>
            <td>{{ getForm.remaining_money | isComma }}円</td>
          </tr>
          <tr v-show="getForm.payment === 'split' || getForm.payment === 'split_bonus'">
            <th>{{ ProductInputText.split_fee }}</th>
            <td>{{ getForm.split_fee | isComma }}円</td>
          </tr>
          <tr v-show="(getForm.payment === 'once' || getForm.payment === 'seconds') && getForm.split_fee">
            <th>{{ ProductInputText.bonus_fee }}</th>
            <td>{{ getForm.split_fee | isComma }}円</td>
          </tr>
          <tr v-show="getForm.payment !== 'monthly'">
            <th>{{ ProductInputText.split_total_payment }}</th>
            <td>{{ getForm.split_total_payment | isComma }}円</td>
          </tr>
          <tr>
            <th>{{ ProductInputText.total_pay }}</th>
            <td>{{ getForm.total_pay | isComma }}円</td>
          </tr>
          <tr>
            <th>{{ ProductInputText.payment }}</th>
            <td>
              {{ PayTypeText[getForm.payment] }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="payment_form">
        <tbody>
          <tr>
            <td colspan="2" class="payment_style_title">{{ PayTypeText[getForm.payment] }}</td>
          </tr>
          <tr v-show="getForm.payment === 'split' || getForm.payment === 'split_bonus'">
            <th>{{ ProductInputText.split_number }}</th>
            <td>{{ getForm.split_number }}回</td>
          </tr>
          <tr v-show="getForm.payment === 'split_bonus'">
            <th>{{ ProductInputText.bonus_combined_addition_amount }}</th>
            <td>{{ getForm.bonus_combined_addition_amount | isComma }}円</td>
          </tr>
          <tr v-show="getForm.payment === 'split_bonus'">
            <th>{{ ProductInputText.bonus_combined_month }}</th>
            <td>{{ getForm.bonus_combined_month1 }}月, {{ getForm.bonus_combined_month2 }}月</td>
          </tr>
          <tr v-show="getForm.payment === 'split_bonus'">
            <th>{{ ProductInputText.bonus_combined_number }}</th>
            <td>{{ getForm.bonus_combined_number }}回</td>
          </tr>
          <tr v-show="getForm.payment === 'once' || getForm.payment === 'seconds'">
            <th>{{ ProductInputText.bonus_once_month }}</th>
            <td>
              {{ getForm.bonus_once_month | dateFormat('YYYY年MM月') }}
            </td>
          </tr>
          <tr v-show="getForm.payment === 'seconds'">
            <th>{{ ProductInputText.bonus_twice_month }}</th>
            <td>
              {{ getForm.bonus_twice_month | dateFormat('YYYY年MM月') }}
            </td>
          </tr>
          <tr>
            <th>{{ ProductInputText.payment_period_start }}</th>
            <td>
              {{ getForm.payment_period_start | dateFormat('YYYY年MM月') }}
            </td>
          </tr>
          <tr>
            <th>{{ ProductInputText.payment_period_end }}</th>
            <td>
              {{ getForm.payment_period_end | dateFormat('YYYY年MM月') }}
            </td>
          </tr>
          <tr>
            <th>{{ ProductInputText.payment_amount_once }}</th>
            <td>{{ getForm.payment_amount_once | isComma }}円</td>
          </tr>
          <tr v-show="getForm.payment !== 'once' && getForm.payment !== 'monthly'">
            <th>{{ ProductInputText.payment_amount_second }}</th>
            <td>{{ getForm.payment_amount_second | isComma }}円</td>
          </tr>
          <tr>
            <th>{{ ProductInputText.person_charge }}</th>
            <td>{{ getForm.person_charge }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div v-if="getHasPayment === 'installment'">
            <div class="segment">詳細情報のご入力</div>
            <div class="table_block">
                <table>
                    <tbody>
                        <tr>
                            <th>商品の引渡</th>
                            <td>
                                有り
                            </td>
                        </tr>
                        <tr v-if="form.product_delivery=='有り'">
                            <th>商品の引渡時期<span class="require" v-if="form.product_delivery=='有り'">必須</span></th>
                            <td>
                                契約成立後5日以内
                            </td>
                        </tr>
                        <tr v-if="form.product_delivery=='有り'">
                            <th>別紙の有無</th>
                            <td>
                                有り
                            </td>
                        </tr>
                        <tr>
                            <th>役務の提供</th>
                            <td>
                                有り
                            </td>
                        </tr>
                        <tr>
                            <th>役務の提供時期</th>
                            <td>
                                3ヶ月<br>
                                2020-10-15~2021-1-15
                                 <el-radio-group v-model="form.service_range_month" size="small">
                                    <el-radio-button :disabled="form.render_the_service!=='有り'" :label="1">1ヶ月</el-radio-button>
                                    <el-radio-button :disabled="form.render_the_service!=='有り'" :label="3">3ヶ月</el-radio-button>
                                    <el-radio-button :disabled="form.render_the_service!=='有り'" :label="6">6ヶ月</el-radio-button>
                                    <el-radio-button :disabled="form.render_the_service!=='有り'" :label="12">12ヶ月</el-radio-button>
                                    <el-radio-button :disabled="form.render_the_service!=='有り'" :label="15">15ヶ月</el-radio-button>
                                    <el-radio-button :disabled="form.render_the_service!=='有り'" :label="18">18ヶ月</el-radio-button>
                                    <el-radio-button :disabled="form.render_the_service!=='有り'" :label="21">21ヶ月</el-radio-button>
                                    <el-radio-button :disabled="form.render_the_service!=='有り'" :label="24">24ヶ月</el-radio-button>
                                </el-radio-group>
                                <hr>
                                <el-date-picker v-model="form.service_range_start" :disabled="form.render_the_service!=='有り'" :editable="false" data-validator-name="service_range_start_require" style="width:155px;"></el-date-picker>
                                〜
                                <el-date-picker v-model="form.service_range_end" :disabled="form.render_the_service!=='有り'" :editable="false" data-validator-name="service_range_end_require" style="width:155px;"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <th>別紙の有無<span class="require" v-if="false">必須</span></th>
                            <td>
                               有り
                            </td>
                        </tr>
                        <tr>
                            <th :class="{pr40: true}">役務提供に際し、<br>販売・販売代理・仲介する<br>関連商品の有無</th>
                            <td>
                                有り
                                <hr>
                                クレジット対象外<br>
                                販売業者名：テスト会社
                                引渡し時期：2020-10-15日ごろ迄
                            </td>
                        </tr>
                        <tr>
                            <th :class="{pr40: true}">付帯する役務・権利の有無</th>
                            <td>
                                有り
                            </td>
                        </tr>

                        <tr v-if="form.has_hutai_privilege==='有り'">
                            <th>内容、提供</th>
                            <td>
                                テスト
                            </td>
                        </tr>
                        <tr v-if="form.has_hutai_privilege==='有り'">
                            <th>移転時期</th>
                            <td>
                                2020-10-15日ごろ迄
                            </td>
                        </tr>
                        <tr>
                            <th>担当者氏名</th>
                            <td>
                                テスト太郎
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> -->

    <div class="btn_wrap">
      <el-button type="primary" icon="el-icon-arrow-left" @click="backPage">前へ戻る</el-button>
      <el-button type="primary" icon="el-icon-arrow-right" @click="nextPage">次へ進む</el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {ProductInputText, PayTypeText} from '../../../util/constants'
import {smoothScroll, helperZenToHan} from '../../../util/helper'
import {mapGetters, mapActions} from 'vuex'

export default {
  data() {
    return {
      form: {},
      ProductInputText,
      PayTypeText
    }
  },
  mounted() {
    this.$emit('page', 'form-product-confirm')
    window.scrollTo(0, 0)
  },
  methods: {
    nextPage() {
      if (this.getHasDoneSms) {
        // this.$emit('transition',3);
        this.$emit('transition', 'form-user-input')
      } else {
        this.$emit('next')
      }
      // this.$router.push({name:'cregit-confirm'})
    },
    backPage() {
      // this.$emit('transition',1);
      this.$emit('back')
    },
    isComma(form) {
      //金額にカンマをつける処理
      this.noneComma(form)
      const num = Number(this.form[form])
      if (isNaN(num)) {
        this.form[form] = 0
      } else {
        if (this.form[form]) this.form[form] = Math.abs(num).toLocaleString()
      }
    },
    noneComma(form) {
      //金額にカンマを省く処理
      if (this.form[form]) this.form[form] = String(this.form[form]).replace(/,/g, '')
    },
    zeroDelete(form) {
      //金額欄0なら削除
      if (this.form[form]) {
        if (this.form[form] == 0) {
          this.form[form] = ''
        }
      }
    },
    adjustRevolvingMonthPay() {
      this.form.revolving_month_pay = helperZenToHan(this.form.revolving_month_pay)
    },
    ...mapActions({
      product_create: 'product/create'
    })
  },
  computed: {
    ...mapGetters({
      getHasPayment: 'status/getHasPayment',
      getHasDoneSms: 'status/getHasDoneSms',
      getForm: 'productInput/getForm',
      getList: 'productInput/getList',
      getHasRegistration: 'status/getHasRegistration',
      getUserInputForm: 'userInput/getForm'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';

#product_confirm {
  .product_titles {
    overflow: hidden;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    p {
      float: left;
      margin-bottom: 0;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #666;
    }

    p.product_name {
      width: 55%;
    }
    p.product_amount {
      width: 15%;
    }
    p.product_price {
      width: 35%;
    }
    p.product_delete {
      width: 10%;
    }
  }
  .product_list {
    margin-bottom: 0;
    list-style: none;
    padding-left: 0;
    margin-bottom: 10px;
    li {
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      .error_message {
        padding: 5px;
        border: 1px solid red;
        margin-top: 8px;
        border-radius: 4px;
      }
    }

    .product_box {
      overflow: hidden;

      .product_name,
      .product_amount,
      .product_price,
      .product_delete {
        float: left;
      }

      .product_name {
        width: 55%;
        padding-right: 10px;
        .el-select {
          width: 100%;
        }
      }

      .product_amount {
        width: 15%;
        padding-right: 10px;
        .el-select {
          width: 100%;
        }
      }

      .product_price {
        width: 35%;
        padding-right: 10px;
        .el-input {
          width: 100%;
        }
      }

      .product_delete {
        width: 10%;
        text-align: center;
      }
    }
  }

  .payment_form {
    // margin-top: 10px;
  }

  .payment_style_title {
    font-size: 12px;
    font-weight: bold;
    color: $--color-primary;
    text-align: center;
  }
}
</style>
